import * as R from 'ramda'
import {
  RECEIVE_DISTRICT_FLYERS,
  RECEIVE_ONE_DISTRICT_FLYER,
  RECEIVE_ONE_SCHOOL_FLYER
} from '../flyers/actions'
import { RECEIVE_ONE_SCHOOL } from '../schools/actions'
import {
  RECEIVE_ERROR,
  RECEIVE_ONE_DISTRICT,
  REQUEST_ONE_DISTRICT,
  RETRIEVE_ONE_DISTRICT_FROM_CACHE
} from './actions'

export const reducer = (
  state = {
    isFetching: false,
    error: '',
    lastUpdated: 0,
    district: {
      name: '',
      schools: [],
      flyers: [],
      treesSaved: 0,
      sheetsSaved: 0,
      branding: {
        logo_url: null,
        logo_alt: null,
        logo_link_url: null
      }
    }
  },
  action
) => {
  switch (action.type) {
    case RECEIVE_ERROR: {
      return {
        ...state,
        isFetching: false,
        error: action.error.message
      }
    }
    case REQUEST_ONE_DISTRICT: {
      return {
        ...state,
        isFetching: true
      }
    }
    case RECEIVE_ONE_DISTRICT_FLYER:
    case RECEIVE_ONE_SCHOOL_FLYER:
    case RECEIVE_DISTRICT_FLYERS: {
      return {
        ...state,
        district: { ...state.district, flyers: [], ...action.district }
      }
    }
    case RECEIVE_ONE_SCHOOL:
    case RECEIVE_ONE_DISTRICT: {
      const concatValues = (k, l, r) =>
        k === 'schools' || k === 'flyers' ? R.uniq(R.concat(l, r)) : r

      const district = R.mergeDeepWithKey(
        concatValues,
        state.district,
        action.district
      )
      return {
        ...state,
        district: { ...state.district, ...district },
        isFetching: false,
        error: '',
        lastUpdated: action.receivedAt
      }
    }
    case RETRIEVE_ONE_DISTRICT_FROM_CACHE:
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/shared/redux/districts/reducer.js